var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _circle, _g, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportingInsights(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m401.097 134.571c-58.815 83.082-186.932 170.373-341.409 134.71 146.88-13.093 246.479-93.231 295.4-164.318l-20.825-13.401c-1.479-.952-2.256-2.531-2.108-4.283s1.178-3.179 2.795-3.87l87.964-37.589c1.448-.619 2.975-.495 4.304.35s2.09 2.175 2.144 3.749l3.323 96.335c.061 1.767-.804 3.313-2.341 4.186s-3.308.825-4.794-.132l-24.453-15.736z",
    fill: "#837683",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m59.688 269.28c146.88-13.093 246.48-93.231 295.4-164.318l-17.355-11.168s-3.498-2.252-3.498-2.252c-1.461-.953-2.227-2.523-2.081-4.264.148-1.752 1.178-3.179 2.795-3.87l82.398-35.211 3.111 90.187c.061 1.767-.803 3.313-2.34 4.186s-3.308.825-4.795-.132l-12.226-7.868-12.227-7.868c-58.815 83.082-174.705 178.241-329.182 142.578z",
    fill: "#a79ba7",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m400.938 174.448h72.702v302.992h-72.702z",
    fill: "#85caff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m454.889 174.448h18.751v302.992h-18.751z",
    fill: "#4eb1fc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m281.087 263.162h72.702v214.278h-72.702z",
    fill: "#43f043"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m335.038 263.162h18.751v214.278h-18.751z",
    fill: "#2dd62d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m161.236 313.036h72.702v164.404h-72.702z",
    fill: "#fcdb35"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m215.187 313.036h18.751v164.404h-18.751z",
    fill: "#fdc72e"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m41.385 352.79h72.702v124.65h-72.702z",
    fill: "#ff5471"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m95.336 352.79h18.751v124.65h-18.751z",
    fill: "#f23353"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120.984,
    cy: 120.402,
    fill: "#4eb1fc",
    r: 109.5,
    transform: "matrix(.707 -.707 .707 .707 -49.702 120.813)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m178.782 197.999c-19.529 18.083-45.657 29.141-74.372 29.141-3.301 0-6.565-.154-9.791-.441-47.738-11.802-83.135-54.912-83.135-106.297 0-55.732 41.636-101.739 95.5-108.613v114.412z",
    fill: "#85caff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.984 10.902c60.475 0 109.5 49.025 109.5 109.5 0 30.238-12.256 57.612-32.072 77.428l-77.428-77.428z",
    fill: "#fcdb35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.984 10.902c60.475 0 109.5 49.025 109.5 109.5h-109.5z",
    fill: "#43f043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.983 10.902c3.301 0 6.565.154 9.791.441 47.738 11.802 83.135 54.912 83.135 106.297 0 26.721-9.576 51.202-25.477 70.211l-67.449-67.449z",
    fill: "#ffeb87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.983 10.902c3.301 0 6.565.154 9.791.441 47.738 11.802 83.135 54.912 83.135 106.297 0 .924-.013 1.844-.035 2.762h-92.892v-109.5z",
    fill: "#adffad"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m14.508 477.44h486.008v23.658h-486.008z",
    fill: "#a79ba7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportingInsights);
export default __webpack_public_path__ + "static/media/reporting-insights.3aaea5347b4f2600cddb2d0763a89850.svg";
export { ForwardRef as ReactComponent };